import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import { Modal } from 'antd';
import { fetchCompanyList } from '@/features/company/companySlice';
import { Button, Form } from '@/components/atoms';
import ManageCompanySearchModal from '@/components/organisms/manage/ManageCompanySearchModal';
import ManageCompanyRegistrationModal from '@/components/organisms/manage/ManageCompanyRegistrationModal';
import ManageUserChangePasswordModal from '@/components/organisms/manage/ManageUserChangePasswordModal';
import ManageUserEditModal from '@/components/organisms/manage/ManageUserEditModal';
import { getMe } from '@/features/account/accountSlice';

const ManagePage = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.account);
  const { list } = useSelector((state: RootState) => state.company);

  const [form] = Form.useForm();

  const [modal, contextHolder] = Modal.useModal();

  const [searchVisible, setSearchVisible] = useState(false);
  const [registrationVisible, setRegistrationVisible] = useState(false);
  const [changePasswordVisible, setChangePasswordVisible] = useState(false);
  const [editUserVisible, setEditUserVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchCompanyList());
  }, [dispatch]);

  return (
    <div className="p-5">
      <h1 className="text-2xl font-bold">사용자 상세 정보</h1>

      <h3 className="text-xl font-bold">회사 정보</h3>
      {list.length === 0 && (
        <>
          <div className="bg-white rounded p-5 flex flex-col justify-center">
            <div>소속된 회사가 없습니다.</div>
          </div>
          <div className="mt-5 flex justify-center space-x-3">
            <Button type="dark" shape="round" onClick={() => setSearchVisible(true)}>
              회사 조회
            </Button>
            <Button type="dark" shape="round" onClick={() => setRegistrationVisible(true)}>
              회사 등록
            </Button>
          </div>
        </>
      )}

      {list.map((company) => (
        <div key={`ready-company-${company.base?.id}`} className="bg-white rounded-md p-3 flex justify-between">
          <div>
            {company.name}
            <small className="ml-4">{company.representative}</small>
          </div>
          {company.statusCode === 100 && <div>승인대기중</div>}
          {company.statusCode === 200 && <div>승인완료</div>}
        </div>
      ))}

      <div className="grid grid-cols-2 gap-2 mt-5">
        <div>
          <h3 className="text-lg font-bold mb-5">서비스 정보</h3>
          <div className="bg-white rounded-md p-5">민원 서비스</div>
        </div>
        <div>
          <h3 className="text-lg font-bold mb-5">사용자 정보</h3>
          <div className="bg-white rounded my-5 p-5">
            <div className="flex items-center">
              {/* <div className="flex-shrink-0 h-10 w-10"> */}
              {/*  <img */}
              {/*    className="h-10 w-10 rounded-full" */}
              {/*    src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=60" */}
              {/*    alt="" */}
              {/*  /> */}
              {/* </div> */}
              <div className="ml-4">
                <div className="text-sm font-medium text-gray-900">{user.name}</div>
                <div className="text-sm text-gray-500">{user.email}</div>
              </div>
            </div>
            <div className="ml-4 mt-5">
              <div className="text-sm font-medium text-gray-900">가입일</div>
              <div className="text-sm text-gray-500">{user.base?.createdAt}</div>
            </div>
          </div>
          <div className="flex justify-center space-x-5">
            <Button type="dark" shape="round" onClick={() => setEditUserVisible(true)}>
              정보 수정
            </Button>
            <Button type="dark" shape="round" onClick={() => setChangePasswordVisible(true)}>
              비밀번호 변경
            </Button>
          </div>
        </div>
      </div>

      <ManageUserEditModal
        visible={editUserVisible}
        onClose={() => {
          setEditUserVisible(false);
          dispatch(getMe());
        }}
      />
      <ManageUserChangePasswordModal visible={changePasswordVisible} onClose={() => setChangePasswordVisible(false)} />
      <ManageCompanySearchModal visible={searchVisible} onClose={() => setSearchVisible(false)} modal={modal} />
      <ManageCompanyRegistrationModal
        visible={registrationVisible}
        onClose={() => {
          setRegistrationVisible(false);
          dispatch(fetchCompanyList());
        }}
      />
      {contextHolder}
    </div>
  );
};

export default ManagePage;
